// To use the retro look, add this to your public/index.html or import via CDN:
// <link rel="stylesheet" href="https://unpkg.com/bootstrap.386@0.1.0/dist/bootstrap-386.min.css">
import React, { useState } from 'react';

const SecurityTerminal = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [output, setOutput] = useState('Welcome to the IKOBU Security Node. Please authenticate.');
  const [loggedIn, setLoggedIn] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (username.toLowerCase() === 'admin' && password === 'station') {
      setLoggedIn(true);
      setOutput('Access granted. Welcome, Commander.\nType HELP for available commands.');
    } else {
      setOutput('Access denied. Invalid credentials.');
    }
  };

  return (
    <div className="container" style={{ minHeight: '100vh', background: '#222', color: '#33ff33', fontFamily: 'monospace', paddingTop: 40 }}>
      <div className="row">
        <div className="col-xs-12 col-md-8 col-lg-6" style={{ margin: '0 auto', background: '#111', border: '2px solid #33ff33', borderRadius: 8, padding: 32, boxShadow: '0 0 16px #33ff3355' }}>
          <h1 style={{ fontFamily: 'monospace', color: '#33ff33', marginBottom: 24 }}>IKOBU STATION // SEC-OPS TERMINAL</h1>
          {!loggedIn ? (
            <form onSubmit={handleLogin} style={{ marginBottom: 24 }}>
              <label style={{ color: '#33ff33' }}>Username:</label>
              <input
                type="text"
                className="form-control"
                style={{ background: '#222', color: '#33ff33', border: '1px solid #33ff33', marginBottom: 12 }}
                value={username}
                onChange={e => setUsername(e.target.value)}
                autoFocus
              />
              <label style={{ color: '#33ff33' }}>Password:</label>
              <input
                type="password"
                className="form-control"
                style={{ background: '#222', color: '#33ff33', border: '1px solid #33ff33', marginBottom: 12 }}
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <button className="btn btn-primary" style={{ background: '#33ff33', color: '#111', border: '1px solid #33ff33', fontWeight: 'bold' }}>Log In</button>
            </form>
          ) : null}
          <div style={{ background: '#181818', color: '#33ff33', minHeight: 120, padding: 16, borderRadius: 4, fontSize: 16, whiteSpace: 'pre-line', border: '1px solid #33ff33' }}>
            {output}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityTerminal; 